import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARWATERLINES_SOURCE_ID = 'miramarWaterLinesSource';

const source = {
  id: MIRAMARWATERLINES_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Miramar_Water_Lines`,
};

export default source;
